"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteHostAction = exports.ChangeHostnameAction = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_core_1 = require("@patternfly/react-core");
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const ChangeHostnameAction = ({ onChangeHostname }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return React.createElement(react_core_1.DropdownItem, { onClick: onChangeHostname }, t('ai:Change hostname'));
};
exports.ChangeHostnameAction = ChangeHostnameAction;
const DeleteHostAction = ({ onDeleteHost }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return React.createElement(react_core_1.DropdownItem, { onClick: onDeleteHost }, t('ai:Remove'));
};
exports.DeleteHostAction = DeleteHostAction;
//# sourceMappingURL=HostToolbarActions.js.map